import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BornToDominate from "./sections/BornToDominate";
import TheSonicIdentity from "./sections/TheSonicIdentity";
import PerformanceArsenal from "./sections/PerformanceArsenal";
import VisualDominance from "./sections/VisualDominance";
import DirectCommand from "./sections/DirectCommand";
import DjTaurxOfficial from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BornToDominate />
      <TheSonicIdentity />
      <PerformanceArsenal />
      <VisualDominance />
      <DirectCommand />
      <DjTaurxOfficial />
    </div>;
}